import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
    selector: 'chapter-list',
    templateUrl: './chapter-list.component.html',
    styleUrls: ['./chapter-list.component.scss']
})
export class ChapterListComponent {

    _Utils = Utils;

    app = inject(MainAppService);

    @Input()
    labelField = "title";
    @Input()
    placeholder = "-Ohne Titel-";
    @Input()
    addText = "";
    @Input()
    emptyItem: any;
    @Input()
    canRearrange = true;
    @Input()
    selectedIndex = 0;

    _items: any[];

    @Output()
    selectedIndexChange = new EventEmitter<[number, boolean]>();
    @Output()
    addItem = new EventEmitter<any>();

    menuItems: MenuItem[];

    
    @Input()
    set items(value: any[]) {
        this._items = value;
        this.selectedIndex = Math.min(this.selectedIndex, value.length - 1);
    }

    addItemClicked(): void {
        this.addItem.emit(null);
        if (this.addItem != null) {
            this._items.push(Utils.cloneDeep(this.emptyItem));
            this.select(this._items.length - 1);
        }
    }

    async deleteItem(): Promise<void> {
        if (await this.app.messageDialog.yesNo(this.app.t("lea.learningContent.chapter.deleteChapterMessage"), this.app.t("general.warning"))) {
            this._items.splice(this.selectedIndex, 1);
            this.select(Math.min(this.selectedIndex, this._items.length - 1), true);
        }
    }

    moveForward(): void {
        if (this.selectedIndex > 0) {
            let temp = this._items[this.selectedIndex];
            this._items[this.selectedIndex] = this._items[this.selectedIndex - 1];
            this._items[this.selectedIndex - 1] = temp;
            this.select(this.selectedIndex - 1);
        }
    }

    moveBackward(): void {
        if (this.selectedIndex < this._items.length - 1) {
            let temp = this._items[this.selectedIndex];
            this._items[this.selectedIndex] = this._items[this.selectedIndex + 1];
            this._items[this.selectedIndex + 1] = temp;
            this.select(this.selectedIndex + 1);
        }
    }

    select(index: number, wasDeleted = false): void {
        this.selectedIndex = index;
        this.selectedIndexChange.emit([index, wasDeleted]);
    }

    openContextMenu(event): void {
        let menuItems: MenuItem[] = [
            {
                label: this.app.t("general.delete"),
                icon: "fas fa-trash",
                command: this.deleteItem.bind(this)
            }
        ];
        if (this.canRearrange) {
            menuItems.push({
                label: this.app.t("lea.learningContent.chapter.moveForward"),
                icon: "fas fa-angle-left",
                command: this.moveForward.bind(this)
            });
            menuItems.push({
                label: this.app.t("lea.learningContent.chapter.moveBackward"),
                icon: "fas fa-angle-right",
                command: this.moveBackward.bind(this)
            });
        }
        this.app.openContextMenu(menuItems);
        event.stopPropagation();
    }

}
